import sofa from './Homeitems/sofa.png';
import sofa1 from './Homeitems/sofa1.gif';
import pack from './Homeitems/packs.gif';
import homedecore from './Homeitems/hsdecor.jpg';
import car from './Homeitems/car.gif';
import bike from './Homeitems/bike.png';
import dimondring from './Homeitems/dimonring.gif';
import heart from './Homeitems/heart.gif';
import heel from './Homeitems/heel.png';
import dimond from './Homeitems/dimond.gif';
import butterfly from './Homeitems/butterfly.gif';
import aquarum from './Homeitems/butterfly.gif';

function Guseritem(props:any){
let itemimg = sofa;
//alert(props.itp);
if(props.itemid == 2) itemimg = car;
else if(props.itemid == 3) itemimg = bike;
else if(props.itemid == 4) itemimg = sofa;
else if(props.itemid == 5) itemimg = sofa1;
else if(props.itemid == 6) itemimg = pack;
else if(props.itemid == 7) itemimg = homedecore;
else if(props.itemid == 8) itemimg = dimondring;
else if(props.itemid == 9) itemimg = heart;
else if(props.itemid == 10) itemimg = heel;
else if(props.itemid == 11) itemimg = dimond;
else if(props.itemid == 12) itemimg = butterfly;
else if(props.itemid == 13) itemimg = aquarum;

//alert(props.itemid);
return(
<div className="per100">
	<div>
        
	<img style={{width:'18vw',height:'100px'}} src={itemimg} className="c-pfp-img" />

	</div>		
		
 </div>
);
}
export default Guseritem;
